import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MinusIcon from 'assets/images/assist/icons/minus.svg?react';
import PlusIcon from 'assets/images/assist/icons/plus.svg?react';
import {
  FaqItemContent,
  HOSTFULLY_ASSIST_HELP_URL,
} from '../HostfullyAssistMarketing.constants';
import {
  FaqAnswer,
  FaqItem,
  FaqToggle,
  FaqToggleSign,
} from '../HostfullyAssistMarketing.styles';

interface FaqDisclosureProps {
  defaultExpanded: boolean;
  index: number;
  item: FaqItemContent;
}

const FaqDisclosure = ({
  defaultExpanded,
  index,
  item,
}: FaqDisclosureProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const { answerKey, questionKey, testId } = item;

  return (
    <FaqItem data-testid={testId}>
      <FaqToggle
        type="button"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((current) => !current)}
        data-testid={`assist-faq-toggle-${index + 1}`}
      >
        {t(questionKey)}
        <FaqToggleSign aria-hidden>
          {isExpanded ? (
            <MinusIcon data-testid={`assist-faq-sign-minus-${index + 1}`} />
          ) : (
            <PlusIcon data-testid={`assist-faq-sign-plus-${index + 1}`} />
          )}
        </FaqToggleSign>
      </FaqToggle>
      {isExpanded && (
        <FaqAnswer>
          <Trans
            i18nKey={answerKey}
            components={{
              salesMail: (
                <a
                  aria-label="sales@hostfully.com"
                  href="mailto:sales@hostfully.com"
                />
              ),
              growthMail: (
                <a
                  aria-label="sales@hostfully.com"
                  href="mailto:growth@hostfully.com"
                />
              ),
              helpArticle: (
                <a
                  aria-label="Hostfully help article"
                  href={HOSTFULLY_ASSIST_HELP_URL}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </FaqAnswer>
      )}
    </FaqItem>
  );
};

export default FaqDisclosure;
